import { MessageDialog } from '../../framework/frontend/MessageDialog';
import { SessionUser } from './SessionUser';

export class Permission {
  static get onlyAdmin(): boolean {
    return (SessionUser.instance?.isAdmin() && !SessionUser.instance?.isClassRoomMember()) || false;
  }

  static get allAccountedUser(): boolean {
    return !SessionUser.instance.isClassRoomMember();
  }

  static get onlyTeacherAndAdmin(): boolean {
    const session = SessionUser.instance;
    if (!session)
      MessageDialog.systemError(
        'セッションインスタンスが取得できませんでした。',
        'onlyTeacherAndAdmin',
        session
      );
    return ((session.isAdmin() || session.isTeacher()) && !session.isClassRoomMember()) || false;
  }

  static get(): boolean {
    return (
      SessionUser.instance.isStandard() ||
      SessionUser.instance.isEnterprise() ||
      SessionUser.instance.isAdmin()
    );
  }
  static get overStandard(): boolean {
    return (
      SessionUser.instance.isStandard() ||
      SessionUser.instance.isEnterprise() ||
      SessionUser.instance.isAdmin()
    );
  }

  static get overEnterprise(): boolean {
    return SessionUser.instance.isEnterprise() || SessionUser.instance.isAdmin();
  }

  static notPermitted(): void {
    MessageDialog.info(`現在のプランでは利用できません`);
  }
}
